<template>
    <div class="reply-manager">
        <div class="plugin-header">
            业务动态
        </div>
        <div class="reply-overview">
            <div class="plugin-card-body">
                <div class="plugin-card-title">
                    动态概览
                </div>
            </div>
            <div class="plugin-card-footer">
                <p class="reply-text">
                    查看动态发布数量排名、统计动态覆盖率
                    <span class="icon-icomoon-right pull-right"></span>
                </p>
            </div>
        </div>
        <div class="reply-statistics">
            <div class="plugin-card-body">
                <div class="plugin-card-title">
                    业务指标统计
                </div>
            </div>
            <div class="plugin-card-footer">
                <p class="reply-text">
                    按区域、按成员统计指定时间的动态数据
                    <span class="icon-icomoon-right pull-right"></span>
                </p>
            </div>
        </div>
        <div class="reply-records">
            <div class="plugin-card-body">
                <div class="plugin-card-title">
                    动态发布记录
                </div>
            </div>
            <div class="plugin-card-footer">
                <p class="reply-text">
                    快速查看地图上动态的发布记录
                    <span class="icon-icomoon-right pull-right"></span>
                </p>
            </div>
        </div>
        <div class="reply-template">
            <div class="plugin-card-body">
                <div class="plugin-card-title">
                    模板管理
                </div>
            </div>
            <div class="plugin-card-footer">
                <p class="reply-text">
                    新增、删除、修改业务动态模板
                    <span class="icon-icomoon-right pull-right"></span>
                </p>
            </div>
        </div>
        <div class="reply-download">
            <div class="plugin-card-body">
                <div class="plugin-card-title">
                    动态下载
                </div>
            </div>
            <div class="plugin-card-footer">
                <p class="reply-text">
                    以Excel格式导出业务动态数据
                    <span class="icon-icomoon-right pull-right"></span>
                </p>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'ReplyManager',
    components: {

    },
    data() {
        return {

        }
    },
    mounted() {


    },
    methods: {


    }
}

</script>

<style scoped>
.reply-manager {
    position: relative;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    scrollbar-width: none;
}

.plugin-header {
    height: 36px;
    padding-left: 10px;
    padding-right: 10px;
    background-color: #edf0f5;
    line-height: 36px;
    color: #576d8b;
}
.reply-overview, .reply-statistics, .reply-records, .reply-template, .reply-download, .reply-upload {
    border: 1px solid transparent;
    cursor: pointer;
    position: relative;
    min-height: 110px;
    background-color: #fff;
    width: 282px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
    margin-top: 12px;
    overflow: hidden;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.3);
    min-height: auto;
}
.reply-overview:hover,.reply-statistics:hover,.reply-records:hover,.reply-template:hover,.reply-download:hover,.reply-upload:hover {
    border: 1px solid #0095ff;
    background-color: #fff;
}


.reply-overview .plugin-card-body, .reply-statistics .plugin-card-body, .reply-records .plugin-card-body, .reply-template .plugin-card-body, .reply-download .plugin-card-body, .reply-upload .plugin-card-body {
    background-color: transparent;
    height: 32px;
}
.reply-overview .plugin-card-body, .reply-statistics .plugin-card-body, .reply-records .plugin-card-body, .reply-template .plugin-card-body, .reply-download .plugin-card-body, .reply-upload .plugin-card-body {
    padding: 10px;
    cursor: pointer;
}
.reply-overview .plugin-card-footer, .reply-statistics .plugin-card-footer, .reply-records .plugin-card-footer, .reply-template .plugin-card-footer, .reply-download .plugin-card-footer, .reply-upload .plugin-card-footer {
    padding: 0 10px;
}
.reply-overview .plugin-card-footer, .reply-statistics .plugin-card-footer, .reply-records .plugin-card-footer, .reply-template .plugin-card-footer, .reply-download .plugin-card-footer, .reply-upload .plugin-card-footer {
    height: 40px;
    line-height: 40px;
}
.reply-overview .plugin-card-footer p.reply-text, .reply-statistics .plugin-card-footer p.reply-text, .reply-records .plugin-card-footer p.reply-text, .reply-template .plugin-card-footer p.reply-text, .reply-download .plugin-card-footer p.reply-text, .reply-upload .plugin-card-footer p.reply-text {
    font-size: 12px;
    color: #576d8b;
}
.reply-overview .plugin-card-footer p.reply-text span, .reply-statistics .plugin-card-footer p.reply-text span, .reply-records .plugin-card-footer p.reply-text span, .reply-template .plugin-card-footer p.reply-text span, .reply-download .plugin-card-footer p.reply-text span, .reply-upload .plugin-card-footer p.reply-text span {
    line-height: 38px;
}
.pull-right {
    float: right !important;
}
</style>